class DimeQuiz extends HTMLElement {
  constructor() {
    super();

    this.questions = [];
    this.currentIndex = 0;
    this.currentQuestion = {};
    this.userData = {};
    this.resultsData = {};

    document
      .querySelector("button[data-next-name-surname]")
      .addEventListener("click", () => {
        this.querySelector("#dime-quiz-intro").style.display = "none";
        this.querySelector("#dime-quiz-name-surname").style.display =
          "contents";
        document.querySelector("#bg-quiz-content").style.backgroundColor =
          "#f1ece6";

        document.querySelector(".main_img").classList.remove("d-xl-block");
        document.querySelector(".name_img").classList.add("d-xl-block");
        document.querySelector("#dime-quiz-content").style.minHeight =
          "calc(100vh - 110px)";
        document
          .querySelector("#dime-quiz-row")
          .classList.remove("skin-quiz-front-page");
        document.querySelector("#dime-quiz-row").style.minHeight =
          "calc(100vh - 110px)";
        document.querySelector(".main-img-mobile").classList.add("d-none");
        document.querySelector(".name-img-mobile").classList.remove("d-none");
      });

    document
      .querySelector("button[data-start-quiz]")
      .addEventListener("click", () => {
        this.startQuiz();
        this.querySelector("#dime-quiz-content").style.position = "relative";
        this.querySelector("#dime-quiz-content").style.minHeight =
          "calc(100vh - 110px)";
        this.querySelector("#dime-quiz-row").style.minHeight =
          "calc(100vh - 110px)";
        this.querySelector("#dime-quiz-questions").style.marginTop = "32px";
        this.querySelector("#dime-quiz-name-surname").style.display = "none";
        this.querySelector(".name-img-mobile").style.display = "none";
        this.querySelector("#question-number").classList.add("d-block");
        this.querySelector("#question-number").classList.remove("d-none");
        document.querySelector(".name_img").classList.remove("d-xl-block");
        document.querySelector(".quiz-questions-img").classList.add("d-none");
      });

    this.handleNameSurname();
  }

  handleNameSurname() {
    this.querySelectorAll("#dime-quiz-name-surname .form-control").forEach(
      (input) => {
        input.addEventListener(
          "input",
          window.debounce((e) => {
            this.userData.first_name = this.querySelector(
              '#dime-quiz-name-surname [name="firstname"]'
            ).value;
            // this.userData.last_name = this.querySelector('#dime-quiz-name-surname [name="lastname"]').value

            let validated = true;

            this.querySelectorAll(
              "#dime-quiz-name-surname .form-control"
            ).forEach((input) => {
              if (input.value.length < 2) {
                validated = false;
              }
            });

            if (validated) {
              this.querySelector(
                "#dime-quiz-name-surname .btn"
              ).disabled = false;
            } else {
              this.querySelector(
                "#dime-quiz-name-surname .btn"
              ).disabled = true;
            }
          })
        );
      }
    );
  }

  async startQuiz() {
    this.querySelector("#dime-quiz-loading").style.display = "block";

    const response = await fetch(
      "https://us-central1-dime-app-8394d.cloudfunctions.net/api/app/get"
    );
    const data = await response.json();
    this.questions = data.quiz.questions;
    // console.log(this.questions)

    this.querySelector("#dime-quiz-loading").remove();
    this.initButtons();
    this.setQuestion();
    this.setProgressBar();
  }

  async sendUserDataToApi() {
    const fpUUID = new Fingerprint({
      canvas: true,
      ie_activex: true,
      screen_resolution: true,
    });
    const uuid = fpUUID.get();
    // const du = new DeviceUUID().parse()

    this.userData.uuid = uuid;
    // this.userData.language = du.language
    // this.userData.userAgent = navigator.userAgent
    // this.userData.cookieEnabled = navigator.cookieEnabled
    // this.userData.platform = navigator.platform
    this.userData.customer_id = window.theme.customer_id;

    this.userData = { ...this.userData, ...this.resultsData };

    // console.log(this.userData)
    // console.log(this.resultsData)

    const response = await fetch(
      "https://us-central1-dime-app-8394d.cloudfunctions.net/api/qz",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.userData),
      }
    );

    // console.log(response)
  }

  setQuestion() {
    this.currentQuestion = this.questions[this.currentIndex];

    let options = "";

    if (this.currentQuestion.id === 6) {
      this.currentQuestion.options = this.currentQuestion.options.sort(
        () => Math.random() - 0.5
      );
    }

    this.currentQuestion.options.forEach((option, index) => {
      options += `
                <div class="form-check">
                    <input id="${
                      this.currentQuestion.slug
                    }-${index}" class="form-check-input" type="${
        this.currentQuestion.type === "checkbox" ? "checkbox" : "radio"
      }" name="${this.currentQuestion.slug}"  value="${
        option.value
      }" data-has-input="${option["has-input"]}" data-skip-next="${
        option["skip-next"]
      }">
                    <label class="form-check-label" for="${
                      this.currentQuestion.slug
                    }-${index}">
                        <div class="w-100 age-label">
                            ${option.label}
                        </div>
                        
                    </label>
                </div>
                <div class="form-control-wrapper" style="display: none">
                    <input name="${
                      this.currentQuestion.slug
                    }" type="text" class="form-control" aria-label="Please specify" placeholder="Please specify..." disabled>
                </div>
            `;
    });
    this.querySelector("#dime-quiz-questions").innerHTML = `
    
            <h2 class="title h3 mb-7 questions-title">
                ${this.currentQuestion.title}
            </h2>
              <div class="wrapper-questions col">
                
      
          
            ${options}
              </div>
        `;
    this.querySelector("#quiz-questions-img").innerHTML = `
    <img
      class="img-fluid w-100 main-img-desktop"
      src=${this.currentQuestion.image_question}
      alt=${this.currentQuestion.image_question}
      width="1080"
      height="1080"
      loading="lazy"/>
    `;

    this.querySelector("#dime-quiz-questions").style.display = "block";
    this.querySelector("#dime-quiz-content").classList.add("in-view-questions");

    this.querySelectorAll(".form-check-input").forEach((input) => {
      input.addEventListener("change", () => {
        document
          .querySelectorAll("#dime-quiz-buttons button")
          .forEach((btn) => {
            btn.removeAttribute("disabled");

            if (input.dataset.hasInput === "true") {
              input.closest(".form-check").nextElementSibling.style.display =
                "block";
              input
                .closest(".form-check")
                .nextElementSibling.querySelector("input").disabled = false;
              input
                .closest(".form-check")
                .nextElementSibling.querySelector("input")
                .focus();
            } else {
              document
                .querySelectorAll(".form-control-wrapper")
                .forEach((element) => {
                  element.style.display = "none";
                  element.querySelector("input").disabled = true;
                });
            }
          });
      });
    });
  }

  async displayNewsletterForm() {
    this.querySelector("#dime-quiz-questions").innerHTML = "";
    this.querySelector("#dime-quiz-buttons").style.display = "none";
    this.querySelector("#dime-quiz-newsletter").style.display = "block";
    document.querySelector("#dime-quiz-content").style.backgroundColor =
      "#F1ECE6";
    // document.querySelector("#dime-quiz-content").style.background = "none";

    document.querySelector("#dime-quiz-row").style.display = "flex";
    document.querySelector(".newsletter-img-mobile").style.order = "2";
    document.querySelector("#dime-quiz-content").style.order = "1";

    document
      .querySelector(".quiz-questions-img")
      .classList.remove("d-xl-block");
    document.querySelector(".newsletter_img").classList.add("d-none");

    document.querySelector(".newsletter-img-mobile").classList.remove("d-none");

    this.querySelector("#dime-quiz-newsletter form").addEventListener(
      "submit",
      async (e) => {
        e.preventDefault();

        const form = e.target;
        const btn = form.querySelector(".btn");

        btn.ariaBusy = "true";
        btn.innerHTML = `
                <div class="spinner-border spinner-border-sm" role="status" >
                    <span class="visually-hidden">Loading...</span>
                </div>
            `;

        this.userData.email = form.querySelector('[name="email"]').value;
        this.userData.phone = form.querySelector('[name="phone"]').value;

        const postBody = {
          g: form.querySelector('[name="g"]').value,
          email: this.userData.email,
          $fields:
            "$first_name,$phone_number,$source,age,ethnicity,gender,type,goal,routine,customer_id",
          $first_name: this.userData.first_name,
          // $last_name: this.userData.last_name,
          $phone_number: this.userData.phone,
          customer_id: window.theme.customer_id,
          $source: "Quiz",
          event: "Quiz completed",
        };

        for (const [key, value] of Object.entries(this.resultsData)) {
          if (key === "goal") {
            let newvalue = value.split(",").reduce(
              (acc, val) => ({
                ...acc,
                [val]: (acc[val] || 0) + 1,
              }),
              {}
            );

            const newvalueSorted = Object.entries(newvalue).sort(
              (a, b) => b[1] - a[1]
            );

            if (
              newvalueSorted[1] &&
              newvalueSorted[0][1] === newvalueSorted[1][1]
            ) {
              let goalValue;

              newvalueSorted.forEach((value) => {
                if (value[0] === "fine-lines-and-wrinkles") {
                  goalValue = "fine-lines-and-wrinkles";
                }
              });

              if (!goalValue) {
                newvalueSorted.forEach((value) => {
                  if (value[0] === "fine-lines-and-wrinkles") {
                    goalValue = "fine-lines-and-wrinkles";
                  }
                });
              }

              if (!goalValue) {
                newvalueSorted.forEach((value) => {
                  if (value[0] === "breakouts-and-blemishes") {
                    goalValue = "breakouts-and-blemishes";
                  }
                });
              }

              if (!goalValue) {
                newvalueSorted.forEach((value) => {
                  if (value[0] === "hyperpigmentation") {
                    goalValue = "hyperpigmentation";
                  }
                });
              }

              if (!goalValue) {
                newvalueSorted.forEach((value) => {
                  if (value[0] === "rosacea-or-redness") {
                    goalValue = "rosacea-or-redness";
                  }
                });
              }

              postBody[key] = goalValue;
            } else {
              postBody[key] = newvalueSorted[0][0];
            }
          } else {
            postBody[key] = value;
          }
        }

        const response = await fetch(
          "//manage.kmail-lists.com/ajax/subscriptions/subscribe",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "cache-control": "no-cache",
            },
            body: new URLSearchParams(postBody),
          }
        );

        // console.log(response)

        const data = await response.json();
        // console.log(data)

        _learnq.push(["identify", { $email: this.userData.email }]);

        setTimeout(function () {
          _learnq.push(["track", "Quiz Completed"]);
        }, 1500);

        if (window.dime_quiz.discount_code.length) {
          this.querySelector("[data-insert-discount-code]").textContent =
            window.dime_quiz.discount_code;
        }

        this.querySelector("#dime-quiz-newsletter").style.display = "none";
        this.displayProducts();
      }
    );
  }

  async displayProducts() {
    let primaryCollectioHandle;
    let secondaryCollectioHandle;

    if (this.resultsData["type-alt"]) {
      this.resultsData.type = this.resultsData["type-alt"];
    }

    switch (this.resultsData.type) {
      case "dry":
        if (this.resultsData.routine === "low") {
          primaryCollectioHandle = "dry-low";
        } else {
          primaryCollectioHandle = "dry-high";
        }
        break;
      case "oily":
        if (this.resultsData.routine === "low") {
          primaryCollectioHandle = "oily-low";
        } else {
          primaryCollectioHandle = "oily-high";
        }
        break;
      case "combination":
        if (this.resultsData.routine === "low") {
          primaryCollectioHandle = "combination-low";
        } else {
          primaryCollectioHandle = "combination-high";
        }
        break;
      case "sensitive":
        if (this.resultsData.routine === "low") {
          primaryCollectioHandle = "sensitive-low";
        } else {
          primaryCollectioHandle = "sensitive-high";
        }
        break;
      case "normal":
        if (this.resultsData.routine === "low") {
          primaryCollectioHandle = "normal-low";
        } else {
          primaryCollectioHandle = "normal-high";
        }
        break;
    }

    const primaryRespone = await fetch(
      `/collections/${primaryCollectioHandle}/products.json`
    );
    const primaryData = await primaryRespone.json();

    const resultsGoal = this.resultsData.goal.split(",").reduce(
      (acc, value) => ({
        ...acc,
        [value]: (acc[value] || 0) + 1,
      }),
      {}
    );

    const resultsGoalSorted = Object.entries(resultsGoal).sort(
      (a, b) => b[1] - a[1]
    );

    if (
      resultsGoalSorted[1] &&
      resultsGoalSorted[0][1] === resultsGoalSorted[1][1]
    ) {
      let goalValue;

      resultsGoalSorted.forEach((value) => {
        if (value[0] === "fine-lines-and-wrinkles") {
          goalValue = "fine-lines-and-wrinkles";
        }
      });

      if (!goalValue) {
        resultsGoalSorted.forEach((value) => {
          if (value[0] === "fine-lines-and-wrinkles") {
            goalValue = "fine-lines-and-wrinkles";
          }
        });
      }

      if (!goalValue) {
        resultsGoalSorted.forEach((value) => {
          if (value[0] === "breakouts-and-blemishes") {
            goalValue = "breakouts-and-blemishes";
          }
        });
      }

      if (!goalValue) {
        resultsGoalSorted.forEach((value) => {
          if (value[0] === "hyperpigmentation") {
            goalValue = "hyperpigmentation";
          }
        });
      }

      if (!goalValue) {
        resultsGoalSorted.forEach((value) => {
          if (value[1] === "rosacea-or-redness") {
            goalValue = "rosacea-or-redness";
          }
        });
      }

      secondaryCollectioHandle = goalValue;
    } else {
      secondaryCollectioHandle = resultsGoalSorted[0][0];
    }

    switch (secondaryCollectioHandle) {
      case "fine-lines-and-wrinkles":
        secondaryCollectioHandle = "customized-for-your-skincare-goals-4";
        break;
      case "breakouts-and-blemishes":
        secondaryCollectioHandle = "customized-for-your-skincare-goals-2";
        break;
      case "hyperpigmentation":
        secondaryCollectioHandle = "customized-for-your-skincare-goals-3";
        break;
      case "rosacea-or-redness":
        secondaryCollectioHandle = "customized-for-your-skincare-goals-1";
        break;
      default:
        break;
    }

    const buildProductList = (product, index) => {
      const badgeElement = product.tags.find((element) =>
        element.startsWith("badge:")
      );
      const badgeValue = badgeElement ? badgeElement.split(":")[1] : null;
      const badgeTagHTML = badgeValue
        ? `<span class="product-tag text-body text-body--medium-medium">
          ${badgeValue}
        </span>`
        : "";

      return `
      <div class="carousel-item ${
        index === 0 ? "active" : ""
      }" data-product-tags="${product.tags}">
          <div class="product-list-item overflow-hidden text-start">
              <a class="img-wrapper d-block position-relative mb-4 hover-effect-shine" href="/products/${
                product.handle
              }">
                  <img 
                      class="product-img img-fluid"
                      src="${window.resizeImage(
                        product.images[0].src || "no-image.gif",
                        "480x480",
                        "center"
                      )}" 
                      alt="${product.images[0].alt}"
                      loading="lazy">
                  ${badgeTagHTML}
              </a>
              <div class="yotpo bottomLine mb-3" data-product-id="${
                product.id
              }"></div>
              <h3 class="product-title title h6 mb-3">
                  <a class="text-decoration-none d-block text-title text-title--medium-medium" href="/products/${
                    product.handle
                  }">
                      ${product.title}
                  </a>
              </h3>
              <p class="product-price mb-4">
                  <s class="product-price-compare text-secondary me-1 ${
                    Number(product.variants[0].compare_at_price_min) >
                    Number(product.variants[0].price)
                      ? ""
                      : "d-none"
                  }">
                      <span class="visually-hidden">
                          Old price
                      </span>
                      ${window.formatMoney(
                        product.variants[0].compare_at_price_min
                      )}
                  </s>
                  <span class="text-body text-body--medium-regular">
                      ${window.formatMoney(product.variants[0].price)}
                  </span>
              </p>
              <form method="post" action="/cart/add" class="shopify-product-form mb-6" 
              enctype="multipart/form-data"               
              onsubmit="onSubmitAtcForm(this, event)"
              data-og-check="true">
                  <input type="hidden" name="id" value="${
                    product.variants[0].id
                  }">
                  <button class="btn-atc btn btn-primary btn-size-extra-small w-100" type="submit">
                      <span>${
                        product.variants[0].available
                          ? "Add to Bag"
                          : "Sold out"
                      }</span>
                  </button>
              </form>
          </div>
      </div>
  `;
    };

    let primaryProductList = "";
    let primaryProductListIndicators = "";

    primaryData.products.slice(0, 3).forEach((product, index) => {
      primaryProductList += buildProductList(product, index);

      primaryProductListIndicators += `
                <button 
                    type="button" 
                    data-bs-target="#dime-quiz-product-carousel-concerns" 
                    data-bs-slide-to="${index}" class="${
        index === 0 ? "active" : ""
      }" 
                    aria-current="${index === 0 ? "true" : "false"}" 
                    aria-label="Slide ${index + 1}">
                </button>
            `;
    });

    this.querySelector(
      "#dime-quiz-product-carousel-concerns .carousel-inner"
    ).insertAdjacentHTML("afterbegin", primaryProductList);

    if (window.Yotpo) {
      const api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    }

    this.querySelector(
      "#dime-quiz-product-carousel-concerns .carousel-indicators"
    ).insertAdjacentHTML("afterbegin", primaryProductListIndicators);
    this.querySelector(
      "#btn-view-recommendations"
    ).href = `/collections/${primaryCollectioHandle}`;

    this.querySelector(
      "#dime-quiz-products-header .container"
    ).insertAdjacentHTML(
      "afterbegin",
      `
            <h2 class="title h5 mb-7 products-header-container">
                Your results have been sent!
            </h2>
            <div class="text-center intro-description mb-9">Results have been sent to your email. Remember to check your spam folders, too.
            You can also view your results right here.</div>
            
        `
    );

    let uniqueGoalsArray = [...new Set(this.resultsData.goal.split(","))];
    let skincareGoalFormat = uniqueGoalsArray.join(", ").replaceAll("-", " ");

    this.querySelector(
      "[data-modal-dialog-name]"
    ).textContent = `Hey, ${this.userData.first_name}!`;
    this.querySelector(
      "[data-modal-dialog-skin-type]"
    ).textContent = `${this.resultsData.type}`;
    this.querySelector(
      "[data-modal-dialog-skin-goals]"
    ).textContent = `${skincareGoalFormat}`;

    localStorage.setItem(
      "skinQuizResults",
      JSON.stringify({
        skinType: this.resultsData.type,
        skincareGoal: skincareGoalFormat,
        code: window.dime_quiz.discount_code,
      })
    );

    this.querySelector("#dime-quiz-row").style.display = "none";
    this.querySelector("#dime-quiz-products").style.display = "block";

    this.querySelector(
      `#dime-quiz-products [data-skin-type="${this.resultsData.type}"]`
    ).style.display = "block";

    const modal = bootstrap.Modal.getOrCreateInstance(
      this.querySelector("#dime-quiz-products-modal")
    );
    modal.show();

    const switchListBtn = this.querySelector(
      "#dime-quiz-btn-swich-product-list"
    );

    switchListBtn.addEventListener("click", () => {
      if (switchListBtn.dataset.mode === "concerns") {
        switchListBtn.setAttribute("data-mode", "goals");
        this.querySelector(
          "#dime-quiz-product-carousel-concerns"
        ).style.display = "block";

        this.querySelector(
          '[data-switch-text="see-recommendations-based"]'
        ).textContent = "See more recommendations based on your skin goals:";
      } else {
        switchListBtn.setAttribute("data-mode", "concerns");
        this.querySelector(
          "#dime-quiz-product-carousel-concerns"
        ).style.display = "none";

        this.querySelector(
          '[data-switch-text="see-recommendations-based"]'
        ).textContent = "See more recommendations based on your skin type:";
      }
    });

    (() => {
      let newText = "";
      const switchText = this.querySelector(
        '[data-switch-text="based-on-product-tag"'
      );
      const tags =
        this.querySelector(".carousel-item").dataset.productTags.split(",");
      tags.forEach((tag) => {
        if (tag.includes("quiz_title")) {
          newText = tag.split(":")[1];
        }
      });
      switchText.textContent = newText;

      document.querySelectorAll(".carousel").forEach((carousel) => {
        carousel.addEventListener("slide.bs.carousel", (event) => {
          const tags = carousel
            .querySelector(`.carousel-item:nth-child(${event.to + 1}`)
            .dataset.productTags.split(",");
          tags.forEach((tag) => {
            if (tag.includes("quiz_title")) {
              newText = tag.split(":")[1];
            }
          });
          switchText.textContent = newText;
        });
      });

      switchListBtn.addEventListener("click", () => {
        let mode =
          switchListBtn.dataset.mode == "concerns" ? "goals" : "concerns";

        const tags = document
          .querySelector(`#dime-quiz-product-carousel-${mode} .carousel-item`)
          .dataset.productTags.split(",");

        tags.forEach((tag) => {
          if (tag.includes("quiz_title")) {
            newText = tag.split(":")[1];
          }
        });
        switchText.textContent = newText;
      });
    })();
  }

  setProgressBar() {
    this.querySelector("#dime-quiz-progress .progress-bar").setAttribute(
      "aria-valuemax",
      this.questions.length
    );
    const questionNumberSpan = this.querySelector("#question-number");
    questionNumberSpan.textContent = `${this.currentIndex + 1}/8`;

    this.querySelector("#dime-quiz-progress .progress-bar").setAttribute(
      "aria-valuenow",
      this.currentIndex + 1
    );

    if (this.currentIndex === 0) {
      this.querySelector("#dime-quiz-progress .progress-bar").style.width =
        "2%";
    } else {
      this.querySelector("#dime-quiz-progress .progress-bar").style.width =
        Math.round((this.currentIndex / this.questions.length) * 100) + "%";
    }

    this.querySelector("#dime-quiz-progress").style.display = "flex";
    this.querySelector("#dime-quiz-progress").style.width = "auto";
  }

  initButtons() {
    this.querySelector("#dime-quiz-buttons").style.display = "flex";
    let skiped = false;

    document.querySelectorAll("#dime-quiz-buttons button").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.hasAttribute("data-next")) {
          if (
            document.querySelector(
              "#dime-quiz-questions .form-check-input:checked"
            ).dataset.skipNext === "true"
          ) {
            this.currentIndex += 2;
            skiped = true;
          } else {
            this.currentIndex += 1;
            skiped = false;
          }
        } else {
          if (skiped === true) {
            this.currentIndex -= 2;
          } else {
            this.currentIndex -= 1;
          }
        }

        if (btn.hasAttribute("data-next")) {
          let value = "";

          const inputText = document.querySelector(
            "#dime-quiz-questions .form-control:not([disabled])"
          );

          if (inputText && inputText.value.length) {
            value = inputText.value;
          } else if (
            document.querySelector('#dime-quiz-questions [type="checkbox"]')
          ) {
            document
              .querySelectorAll(
                "#dime-quiz-questions .form-check-input:checked"
              )
              .forEach((element) => {
                value += element.value + ",";
              });
            value = value.slice(0, -1);
          } else {
            value = document.querySelector(
              "#dime-quiz-questions .form-check-input:checked"
            ).value;
          }

          this.resultsData[this.currentQuestion.slug] = value;
        } else {
          delete this.resultsData[this.currentQuestion.slug];
        }

        if (this.currentIndex === this.questions.length) {
          this.displayNewsletterForm();
          this.sendUserDataToApi();
        } else {
          this.setQuestion();
        }

        this.setProgressBar();

        if (this.currentIndex === 0) {
          this.querySelector(
            "#dime-quiz-buttons button[data-prev]"
          ).style.display = "none";
          this.querySelector(
            "#dime-quiz-buttons button[data-next]"
          ).style.display = "block";
        } else if (this.currentIndex === this.questions.length) {
          this.querySelector(
            "#dime-quiz-buttons button[data-prev]"
          ).style.display = "block";
          this.querySelector(
            "#dime-quiz-buttons button[data-next]"
          ).style.display = "none";
        } else {
          this.querySelector(
            "#dime-quiz-buttons button[data-prev]"
          ).style.display = "block";
          this.querySelector(
            "#dime-quiz-buttons button[data-next]"
          ).style.display = "block";
        }

        this.querySelector("#dime-quiz-buttons button[data-next]").setAttribute(
          "disabled",
          "disabled"
        );

        document
          .querySelectorAll("#dime-quiz-buttons button")
          .forEach((btn) => {
            btn.blur();
          });

        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    });
  }
}

customElements.define("dime-quiz", DimeQuiz);
